import { Route, Switch } from 'react-router-dom';
import { OrdersLabelGenerateStatusPage } from './pages/LabelGenerateStatusPage';
import OrdersPrintDocumentsPage from './pages/PrintDocumentsPage/PrintDocumentsPage';
import { NUVEM_ENVIO_ORDERS_ROUTES } from './routes';

function NuvemEnvioOrders(): JSX.Element {
  return (
    <Switch>
      <Route
        exact
        path={NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintLabelStatus}
      >
        <OrdersLabelGenerateStatusPage />
      </Route>
      <Route
        exact
        path={NUVEM_ENVIO_ORDERS_ROUTES.ordersNuvemEnvioPrintDocuments}
      >
        <OrdersPrintDocumentsPage />
      </Route>
    </Switch>
  );
}

export default NuvemEnvioOrders;
